<template>
  <div>
    <div v-for="(item, i) in ulListCheck" :key="i" class="flex items-center">
      <img :src="checkIcon" alt="check" width="20" class="mr-2" /> {{ item.li }}
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      checkIcon:"/icons/check.png"
    }
  },
  props: ["ulListCheck"],
};
</script>